import AuthenticationService from '@/services/AuthenticationService';
import ActionService from "@/services/ActionService";

export default {
  data() {
    return {
      SurveyImprovementStatus: ActionService.SurveyImprovementStatus
    };
  },

  computed: {
    getImprovementStatusOptions() {
      return [
        { value: this.SurveyImprovementStatus.New, text: this.getImprovementStatusText(this.SurveyImprovementStatus.New) },
        { value: this.SurveyImprovementStatus.Revised, text: this.getImprovementStatusText(this.SurveyImprovementStatus.Revised) },
      ];
    },

    notificationSettingsRoute() {
      return this.$router.currentRoute.path.startsWith("/external") ?
        {name: 'ExternalNotificationSettings'} :
        {name: 'Notification settings'};
    }
  },

  methods: {
    hasSurveyImprovement() {
      return APP_TARGET === "bmw";
    },

    userHasActionImprovementPermission: function() {
      return this.hasSurveyImprovement() && AuthenticationService.localUserProfile.Permissions.includes('ActionsImprove');
    },

    getImprovementCreatedText(surveyImprovement) {
      let at = surveyImprovement.CreatedAt ? this.$options.filters.msm_timefromnow(surveyImprovement.CreatedAt) : null;
      let by = surveyImprovement.CreatedBy ?
        `${surveyImprovement.CreatedBy.FirstName} ${surveyImprovement.CreatedBy.LastName}` +
        (surveyImprovement.CreatedBy.Email ? ` (${surveyImprovement.CreatedBy.Email})` : '')
        : null;

      return this.$t('Webportal.Created') + ' ' + at +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getImprovementLastUpdatedText(surveyImprovement) {
      let at = this.$options.filters.msm_timefromnow(surveyImprovement.ModifiedAt ? surveyImprovement.ModifiedAt : surveyImprovement.CreatedAt);
      let by = surveyImprovement.ModifiedAt && surveyImprovement.ModifiedBy ?
        `${surveyImprovement.ModifiedBy.FirstName} ${surveyImprovement.ModifiedBy.LastName}` :
        !surveyImprovement.ModifiedAt && surveyImprovement.CreatedBy ?
          `${surveyImprovement.CreatedBy.FirstName} ${surveyImprovement.CreatedBy.LastName}` : null;

      return this.$t('Webportal.LastUpdated', { at }) +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getImprovementStatusText(statusId) {
      switch (statusId) {
        case this.SurveyImprovementStatus.New:
          return this.$t('Reporting.CheckImprovement.StatusNew');
        case this.SurveyImprovementStatus.Revised:
          return this.$t('Reporting.CheckImprovement.StatusRevised');
      }
    },

    getImprovementStatusIcon(statusId) {
      switch (statusId) {
        case this.SurveyImprovementStatus.New:
          return "exclamation-circle";
        case this.SurveyImprovementStatus.Revised:
          return "check-circle";
        }
    },

    isSurveyImprovementAllowed(surveyInstance) {
      return surveyInstance.IsVisibleForQuery;
    }
  }
};
